import { format } from 'date-fns';

import { AdminEventTransactionsQuery } from '../../apollo/__generated__/graphql';
import { isDateString } from '../../services/date';

type DownloadableTransaction =
  AdminEventTransactionsQuery['eventTransactions'][0];

const downloadCSV = (filename: string, text: string) => {
  const csvContent = 'data:text/csv;charset=utf-8,' + encodeURIComponent(text);
  const link = document.createElement('a');
  link.href = csvContent;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const sanitize = (value: string | null | undefined) =>
  (value ?? '').replaceAll('\n', '').replaceAll(',', ';');

const formatDate = (value: unknown) => {
  if (value instanceof Date) {
    return format(value, 'dd/MM/yyyy HH:mm:ss');
  }

  if (typeof value === 'string' && isDateString(value)) {
    return format(value, 'dd/MM/yyyy HH:mm:ss');
  }

  return sanitize(typeof value === 'string' ? value : String(value ?? ''));
};

const formatTransactionsAsCsv = (transactions: DownloadableTransaction[]) => {
  if (transactions.length === 0) {
    return '';
  }

  const csvHeader = [
    'ID',
    'Participant',
    'Email participant',
    'Payeur',
    'Email payeur',
    'Statut',
    'Type',
    'Réduction',
    'Code réduction',
    'HelloAsso OID',
    'HelloAsso CID',
    'Créé le',
    'Màj le',
  ].join(',');

  const rows = transactions
    .map((transaction) =>
      [
        transaction.id,
        sanitize(
          `${transaction.user.firstname ?? ''} ${transaction.user.lastname ?? ''}`.trim(),
        ),
        sanitize(transaction.user.email),
        sanitize(
          `${transaction.payer.firstname ?? ''} ${transaction.payer.lastname ?? ''}`.trim(),
        ),
        sanitize(transaction.payer.email),
        transaction.status,
        transaction.type,
        transaction.voucher ? `-${transaction.voucher.amount / 100}EUR` : '',
        sanitize(transaction.voucher?.code),
        sanitize(transaction.helloAssoOrderId),
        sanitize(transaction.helloAssoCheckoutIntentId),
        formatDate(transaction.createdAt),
        formatDate(transaction.updatedAt),
      ].join(','),
    )
    .join('\n');

  return `${csvHeader}\n${rows}`;
};

export const downloadTransactionsAsCsv = (
  transactions: DownloadableTransaction[],
) => {
  const csvData = formatTransactionsAsCsv(transactions);
  downloadCSV('transactions.csv', csvData);
};
